import React from 'react';
import PropTypes from 'prop-types';
import RightPaneContentTabs from '../right-pane/right-pane-content-tabs';

export const ClaimedDomainDetailsContentTabs = ( { handleTabChange, tabIndex } ) => {
    const tabData = [
        {
            dataAutomationId: 'cdd-general-tab',
            label: 'General',
        }
    ];

    return (
        <RightPaneContentTabs
            handleTabChange={handleTabChange}
            tabData={tabData}
            tabIndex={tabIndex}
        />
    );
};

ClaimedDomainDetailsContentTabs.propTypes = {
    handleTabChange: PropTypes.func.isRequired,
    tabIndex: PropTypes.number.isRequired
};

export default ClaimedDomainDetailsContentTabs;
